// Capture before Firebase / Phi analytics initialize. Fragments never reach Netlify logs.
let token = '';
if (typeof window !== 'undefined' && /^\/partner\/?$/.test(window.location.pathname)) {
  token = window.location.hash.slice(1);
  window.history.replaceState(null, '', window.location.pathname);
}
// Pure read also works when React StrictMode calls state initializers twice.
export function takePartnerToken() { return token; }
